import { useState } from "react";
import Button from "../ui/Button";
import Tags from "../ui/Tags";
import { ConfirmModal } from "../modals/Confirm";
import { fileAt, isLocked } from "../../utils/cashier/deliveryDocumentation";
import { useAppLabel } from "../../utils/useAppLabel";
import { useCashierText } from "./cashierText";
export default function OrderCard({
  order,
  onEvidence,
  onDeleteEvidence,
  onDetails,
  onDelete,
  onRevertConclusion,
}) {
  const [revertingId, setRevertingId] = useState("");
  const [revertConfirmation, setRevertConfirmation] = useState(null);
  const [isShown, setIsShown] = useState(false);
  const [error, setError] = useState("");
  const appLabel = useAppLabel();
  const { t, locale, evidenceTypes, conclusion, reason } = useCashierText();
  const [store, branch, app] = [
    order.storeSnapshot?.name,
    order.branchSnapshot?.name,
    appLabel(order.applicationSnapshot?.app, order.applicationSnapshot?.name),
  ];
  const locked = isLocked(order);
  const activeConclusions =
    order.activeConclusions ||
    order.conclusions?.filter((item) => !item.revertedAt) ||
    [];

    
  const confirmRevert = async () => {
    const item = revertConfirmation;
    if (!item) return;
    setRevertConfirmation(null);
    setRevertingId(item._id);
    setError("");
    try {
      await onRevertConclusion(item._id);
    } catch (e) {
      setError(e.message);
    } finally {
      setRevertingId("");
    }
  };


  return (
    <article className="cashier-order">
      <div
        className="cashier-order-head"
        onClick={() => setIsShown((prev) => !prev)}
      >
        <div className="cashier-identity">
          <div className="cashier-icon">#</div>
          <div>
            <div className="cashier-title">
              {store} · <span dir="ltr">#{order.last4}</span>
            </div>
            <div className="cashier-meta">
              {app} · {branch}
            </div>
          </div>
        </div>
        <div className="cashier-statuses">
          <Tags
            variant={order.documentationStatus === "complete" ? "success" : "warning"}
            className={`cashier-status ${order.documentationStatus}`}
          >
            {order.documentationStatus === "complete" ? t.complete : t.pending}
          </Tags>
          {activeConclusions.slice(0, 2).map((item) => (
            <Tags
              variant="danger"
              className="cashier-status secondary"
              key={item._id || item.type}
            >
              {conclusion(item.type)}
            </Tags>
          ))}
          {activeConclusions.length > 2 && (
            <Tags variant="neutral" className="cashier-status secondary">
              +{activeConclusions.length - 2}
            </Tags>
          )}
        </div>
      </div>
      <div className={`cashier-progress ${order.documentationStatus}`}>
        <span style={{ width: `${order.percentage || 0}%` }} />
      </div>
      {isShown && (
        <>
          <div className="cashier-meta cashier-time">
            {t.created}: {new Date(order.createdAt).toLocaleString(locale)}{" "}
            {locked && `· ${t.windowClosed}`}
          </div>
          <div className="cashier-evidence">
            {evidenceTypes.map((type) => {
              const file = fileAt(order, type.key);
              const required = order.requiredEvidenceTypes?.includes(type.key);
              return (
                <div
                  className={`cashier-slot ${locked ? "locked" : ""}`}
                  key={type.key}
                  onClick={() =>
                    !locked && onEvidence(order, type, Boolean(file))
                  }
                >
                  {file ? (
                    <img src={file.url} alt={type.label} />
                  ) : (
                    <>
                      <b>＋</b>
                      <span>
                        {type.label}
                        {!required && <small>{t.optional}</small>}
                      </span>
                    </>
                  )}
                  {file && !locked && (
                    <Button
                      variant="danger"
                      appearance="filled"
                      rounded
                      onClick={(e) => {
                        e.stopPropagation();
                        onDeleteEvidence(order, type);
                      }}
                      aria-label={t.deletePhoto}
                    >
                      ×
                    </Button>
                  )}
                </div>
              );
            })}
          </div>
          <div className="cashier-tools">
            {!locked && (
              <Button variant="neutral" onClick={() => onDetails(order)}>
                {t.outcomeAndNotes}
              </Button>
            )}
            {!locked && (
              <Button variant="danger" onClick={() => onDelete(order)}>
                {t.deleteOrder}
              </Button>
            )}
          </div>
          
        {error && <div className="cashier-notice">{error}</div>}
          {order.activeConclusions &&
            order.activeConclusions.map((item) => (
              <div key={item._id} className="cashier-note">
                {conclusion(item.type)}:
                {reason(item.type, item.reason)}:{item.note}
                <Button
                  type="button"
                  variant="danger"
                  disabled={revertingId === item._id}
                  onClick={() => setRevertConfirmation(item)}
                >
                  {revertingId === item._id ? t.reverting : t.revert}
                </Button>
              </div>
            ))}
          {order.outcomeNotes &&
            order.outcomeNotes.map((note) => (
              <div key={note._id} className="cashier-note">
                {note.text}
              </div>
            ))}
        </>
      )}
      {revertConfirmation && (
        <ConfirmModal
          title={t.confirmRevert}
          message={t.revertQuestion(conclusion(revertConfirmation.type))}
          confirmText={t.yesRevert}
          cancelText={t.cancel}
          onConfirm={confirmRevert}
          onCancel={() => setRevertConfirmation(null)}
        />
      )}
    </article>
  );
}
